import styled from 'styled-components';
import {
  borderRadius,
  buttonStyle,
  space,
  fontSize,
  fontWeight,
  lineHeight,
  variant,
  flexbox,
  width,
  background
} from 'styled-system';

import { colors } from '@styles/theme';

const buttonSize = variant({
  prop: 'size',
  key: 'buttonSizes'
});

function disabledStyles(props) {
  const { variant } = props;
  const styles = {};

  if (variant === 'primary') {
    styles.boxShadow = 'none';
    styles.backgroundColor = colors.lighterGreen;
  } else {
    styles.backgroundColor = colors.lighterGray;
    styles.boxShadow = 'none';
  }

  styles.cursor = 'auto';

  return styles;
}

function activeStyles(props) {
  const { variant } = props;
  const styles = {};

  if (variant === 'primary') {
    styles.backgroundColor = colors.darkGreen;
    styles.boxShadow = '0px 1px 2px 0px rgba(4, 84, 67, 0.5)';
  } else {
    styles.backgroundColor = colors.gray;
    styles.boxShadow = 'none';
  }

  return styles;
}
function defaultStyles(props) {
  const { variant } = props;
  const styles = {};

  if (props.disabled) {
    return disabledStyles(props);
  }

  if (props.selected) {
    return activeStyles(props);
  }

  if (variant === 'primary') {
    styles.boxShadow =
      '0px 1px 2px 0px rgba(4, 84, 67, 0.1), 0px 3px 6px 0px rgba(16, 107, 87, 0.25)';
  } else {
    styles.boxShadow = 'none';
  }

  return styles;
}

function hoverStyles(props) {
  const { variant } = props;
  const styles = {};

  if (props.disabled) {
    return disabledStyles(props);
  }

  if (props.selected) {
    return activeStyles(props);
  }

  if (variant === 'primary') {
    styles.boxShadow =
      '0px 1px 3px 0px rgba(4, 84, 67, 0.25),0px 2px 8px 0px rgba(16, 107, 87, 0.5)';
    styles.backgroundColor = colors.lightGreen;
  } else {
    styles.backgroundColor = colors.lighterGray;
    styles.boxShadow = 'none';
  }

  return styles;
}

const Button = styled('button')`

  appearance: button;
  cursor: pointer;
  border: 0;
  outline: 0;

  &:enabled {
    ${props => defaultStyles(props)}
  }
  

  &:disabled {
    ${props => disabledStyles(props)}
  }

  &:hover {
    ${props => hoverStyles(props)}
  }

  &:active {
    ${props => activeStyles(props)}
  }

  ${borderRadius}
  ${buttonStyle}
  ${buttonSize}
  ${space}
  ${width}  
  ${fontSize}
  ${fontWeight}
  ${lineHeight}
  ${flexbox}
  ${background}
`;

Button.defaultProps = {
  variant: 'primary',
  size: 'medium',
  borderRadius: 4,
  fontSize: 2,
  lineHeight: 1.29,
  fontWeight: 'normal'
};

export default Button;
